import clsx from "clsx";
import { CloseIcon, SearchIcon } from "../Icon";

type Props = {
  searchText: string;
  handleOnChange: (text: string) => void;
  additionalClasses?: string;
};

function SearchInput({ handleOnChange, searchText, additionalClasses }: Props) {
  return (
    <div
      className={clsx(
        "flex items-center rounded-ll border-1 border-secondary border-opacity-20 bg-white",
        additionalClasses,
      )}
    >
      <div>
        <SearchIcon className="h-4 w-4 text-primary 2xl:h-6 2xl:w-6" />
      </div>

      <div className="grow">
        <input
          className="w-full border-none bg-transparent px-2 py-0
           font-satoshi text-sm font-medium leading-7 
           text-primary placeholder:opacity-20 focus:outline-none 
           focus:ring-0  
           2xl:px-3 2xl:text-lg"
          type="text"
          value={searchText}
          placeholder="Search"
          onChange={(e) => handleOnChange(e.target.value)}
        />
      </div>
      {/* show close button only when input consist on any value. */}
      {searchText.length > 0 && (
        <div
          className="cursor-pointer rounded-full bg-primary bg-opacity-10 p-1 2xl:p-2"
          onClick={() => handleOnChange("")}
        >
          <CloseIcon className="text-clay-brown h-2 w-2" />
        </div>
      )}
    </div>
  );
}

export default SearchInput;
